import React from 'react';
import MaterialIcon from '@material-ui/core/Icon';
import { Box, Flex } from 'rebass';

import TCIcon from '../../TCIcon';

const getIconComponent = (type = 'material', name, iconStyle = {}) => {
  switch (type) {
    case 'tcst':
      return <TCIcon name={name} />;
    case 'material':
    default:
      return (
        <MaterialIcon
          fontSize="inherit"
          style={{
            verticalAlign: 'middle',
            ...iconStyle,
          }}
        >
          {name}
        </MaterialIcon>
      );
  }
};

const Icon = ({ name, type, iconStyle, containerStyle = {}, ...restProps }) => (
  <Box style={{ display: 'inline-block', ...containerStyle }} {...restProps}>
    {getIconComponent(type, name, iconStyle)}
  </Box>
);

export default Icon;
